import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { PageMenu } from '../../../../components'
import { IconEntregasBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function EntregaMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.ENTREGAS, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 75,
      content: { menu: '3.1 - Ciclos de Entrega', path: '/main/entregas/ciclo-entrega' },
    },
    {
      id: 76,
      content: {
        menu: '3.2 - Transferência de Entrega entre Trechos',
        path: '/main/entregas/transferencia-entrega',
      },
    },
    {
      id: 77,
      content: {
        menu: '3.3 - Recebimento de Transferência de Entrega',
        path: '/main/entregas/recebimento-transferencia-entrega',
      },
    },
    {
      id: 78,
      content: {
        menu: '3.4 - Carregamento de Veículos de Entrega',
        path: '/main/entregas/carregamento-veiculos',
      },
    },
    {
      id: 79,
      content: {
        menu: '3.5 - Emitir Mapa de Carga / Entrega',
        path: '/main/entregas/mapa-de-carga',
      },
    },
    {
      id: 80,
      content: {
        menu: '3.6 - Emitir Mapa de Carga - Analítico',
        path: '/main/entregas/mapa-de-carga-analitico',
      },
    },
    {
      id: 81,
      content: {
        menu: '3.7 - Envio de Veículo de Entrega para Rota',
        path: '/main/entregas/enviar-veiculos',
      },
    },
    {
      id: 82,
      content: {
        menu: '3.8 - Retorno do Veículo de Entrega para Rota',
        path: '/main/entregas/retornar-veiculos',
      },
    },
    {
      id: 83,
      content: {
        menu: '3.9 - Entregas Por Empresa Analítico',
        path: '/main/entregas/entrega-por-empresa-analitico',
      },
    },
    {
      id: 84,
      content: {
        menu: '3.10 - Entregas Para Roteirização',
        path: '/main/entregas/entrega-para-roteirizacao',
      },
    },
    // {
    //   id: 85,
    //   content: {
    //     menu: '3.11 - Endereçamento das Entregas - Estoque',
    //     path: '/main/entregas/enderecamento-das-entregas',
    //   },
    // },
    {
      id: 86,
      content: {
        menu: '3.12 - Roteirização Prévia das Entregas',
        path: '/main/entregas/roteirizacao-previa-das-entregas',
      },
    },
    {
      id: 30,
      content: {
        menu: '3.13 - Importação Multiplos Ciclos de Entrega',
        path: '/main/entregas/multiplo-ciclo-entrega',
      },
    },
    {
      id: 87,
      content: {
        menu: '3.14 - Rastreabilidade Pallet - Entrega',
        path: '/main/entregas/rastreabilidade-pallet',
      },
    },
    {
      id: 88,
      content: {
        menu: '3.15 - Informações de Horário Saida',
        path: '/main/entregas/informacoes-horario-saida',
      },
    },
    {
      id: 89,
      content: {
        menu: '3.16 - Justificativa de Cargas Paradas',
        path: '/main/entregas/justificativa-cargas-paradas',
      },
    },
    {
      id: 90,
      content: { menu: '3.17 - Gestão de Canhotos', path: '/main/entregas/gestao-canhotos' },
    },
    {
      id: 40,
      content: { menu: "3.18 - Gestão de CTe's", path: '/main/entregas/gestao-ctes' },
    },
    {
      id: 91,
      content: { menu: "3.19 - Gestão de MDFe's", path: '/main/entregas/gestao-mdfes' },
    },
    {
      id: 92,
      content: {
        menu: '3.20 - Listagem Tag Pallet',
        path: '/main/entregas/listagem-tag-pallet',
      },
    },
    {
      id: 93,
      content: {
        menu: '3.21 - Histórico de Veículos Retornados',
        path: '/main/entregas/veiculos-retornados',
      },
    },
    {
      id: 94,
      content: {
        menu: '3.22 - Emissão CTe Globalizado',
        path: '/main/entregas/emissao-cte-globalizado',
      },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconEntregasBlue} alt="Icon Tela de Picking" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>3. Entrega</span>
      </PageMenu>{' '}
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(EntregaMenu)
